import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Typography } from "antd";
import { useFieldArray, Control } from "react-hook-form";
import "./representation-form-author.scss";
import { FormItem } from "react-hook-form-antd";

interface RepresentationFormAuthorProps {
  control: Control<any>;
}

export function RepresentationFormAuthor({
  control,
}: RepresentationFormAuthorProps) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "projectSections",
  });

  const handleAddSection = () => {
    append({ name: "", number: "" });
  };

  if (fields.length < 1) {
    append({ name: "", number: "" });
  }


  return (
    <Form>
      <Typography.Title
        level={5}
        style={{ marginTop: "32px", marginBottom: "16px" }}
      >
        Сведения о разделах проектной документации, подготовленных этим лицом
      </Typography.Title>
      {fields.map((field, index) => (
        <div key={field.id} className="author-inputs-container">
          <div className="author-input-main-container">
            <div className="input-label-text">Раздел</div>
            <FormItem
              control={control}
              name={`projectSections.${index}.name`}
              style={{ margin: 0 }}
            >
              <Input />
            </FormItem>
          </div>
          <div className="author-input-number-container">
            <div className="input-label-text">Номер</div>
            <div className="author-input-number-wrapper">
              <FormItem
                control={control}
                name={`projectSections.${index}.number`}
                style={{ margin: 0, width: "60%" }}
              >
                <Input className="author-input-number" />
              </FormItem>
              {index === fields.length - 1 ? (
                <Button
                  type="text"
                  onClick={handleAddSection}
                  style={{
                    backgroundColor: "rgba(24, 144, 255, 0.3)",
                    color: "rgba(24, 144, 255, 1)",
                    width: "40%",
                    marginLeft: "8px",
                  }}
                  icon={
                    <div>
                      <PlusOutlined />
                    </div>
                  }
                >
                  Добавить
                </Button>
              ) : (
                <Button
                  type="text"
                  danger
                  onClick={() => remove(index)}
                  style={{ width: "40%", marginLeft: "8px" }}
                >
                  Удалить
                </Button>
              )}
            </div>
          </div>
        </div>
      ))}
    </Form>
  );
}
